var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 822,
    height: 591,
    viewBox: "0 0 822 591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.046 245.179C227.65 286.231 200.978 523.543 166.393 578.739C166.393 578.739 120.252 616.359 113.134 559.782C106.728 508.688 122.513 280.038 125.612 236.182C125.821 233.253 122.555 231.37 120.127 233.044C104.76 243.547 64.2297 270.748 49.1144 275.769C30.2728 282.004 8.91885 281.837 4.81555 277.862C2.26145 275.393 -9.37852 254.218 16.3718 226.976C16.3718 226.976 138.005 102.566 211.362 77.7509C284.719 52.9359 403.924 -1.92505 461.915 0.0417463C494.532 1.17161 495.704 16.1109 490.47 28.9996C486.116 39.7124 477.7 48.2491 467.232 53.2288C440.98 65.6991 373.61 96.4564 315.913 111.647C315.913 111.647 284.761 121.523 289.869 134.537C294.978 147.551 358.537 294.642 362.473 313.933C366.408 333.225 383.785 383.315 364.441 405.787C345.096 428.258 304.482 381.725 273.289 317.867C251.223 272.631 242.974 252.042 237.95 243.798C236.359 241.162 232.339 242.125 232.004 245.179H232.046Z",
    fill: "#4342C7",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.888 20.1281C196.456 35.8624 189.422 53.4798 175.27 59.5058C161.118 65.5317 145.374 57.6227 139.848 42.0557C134.321 26.4888 141.187 8.91317 155.214 2.80356C169.241 -3.30605 185.319 4.39374 190.888 20.1281Z",
    fill: "#4342C7",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.817 198.604C654.058 198.604 626.801 262.462 624.456 282.004C622.069 301.505 600.799 284.976 600.799 284.976L604.944 198.604L499.598 221.076C499.598 221.076 480.087 218.816 488.335 205.592C496.584 192.369 580.073 163.411 588.531 146.254C596.989 129.097 572.537 40.0053 589.327 30.5061C606.117 21.007 636.473 123.95 639.613 132.445C642.753 140.939 676.71 161.235 688.518 163.788C700.325 166.34 750.737 193.499 743.954 205.174C733.319 223.503 655.775 198.562 655.775 198.562L655.817 198.604Z",
    fill: "#4342C7",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.123 105.203C698.776 112.819 696.515 124.745 688.057 131.859C679.599 138.973 668.252 138.555 662.641 130.98C657.031 123.406 659.208 111.522 667.624 104.408C676.04 97.2938 687.471 97.6286 693.165 105.203H693.123Z",
    fill: "#4342C7",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.059 197.098C423.059 197.098 581.078 461.485 588.154 466.799C595.23 472.114 784.61 398.171 796.459 400.556C796.459 400.556 823.675 394.656 821.917 417.127C820.158 439.599 710.081 498.728 683.451 517.099C656.821 535.47 637.896 538.985 634.337 541.956C630.778 544.927 579.319 591.042 545.572 551.999C511.824 512.956 401.161 260.998 389.939 234.969C378.718 208.94 361.551 172.283 382.235 166.968C402.919 161.654 423.059 197.14 423.059 197.14V197.098Z",
    fill: "#4342C7",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.901 408.709C670.753 394.516 680.305 370.458 670.237 354.975C660.168 339.491 634.292 338.446 612.44 352.639C590.588 366.833 581.036 390.891 591.104 406.374C601.173 421.857 627.049 422.903 648.901 408.709Z",
    fill: "#4342C7",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 822,
    height: 591,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIcon);
export default __webpack_public_path__ + "static/media/bg-icon.edc2a35406e067954e68b90a9e09fd7d.svg";
export { ForwardRef as ReactComponent };